<div class="lock-column-container">
  <div>
    <mat-icon
      class="small-lock-icon"
      *ngIf="isSticky(columnName) || isStickyEnd(columnName)"
      (click)="lockColumns($event, columnName)"
      >lock</mat-icon
    >
    <mat-icon
      class="small-lock-icon"
      *ngIf="!isSticky(columnName) && !isStickyEnd(columnName)"
      (click)="lockColumns($event, columnName)"
      >lock_open</mat-icon
    >
  </div>
  <span>
    {{ displayName }}
  </span>
</div>
